import './index.scss';
import { TFunction } from 'i18next';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  openOldModalAction,
  closeOldModalAction,
} from '../../../../../store/modal/modalActions';
import { store } from '../../../../../store/store';
import Toast from '../../../../shared/Toast/Toast';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AUTH_NAMESPACE } from '../../../../../store/Auth/authReducer';
import { ToastTypeEnum } from '../../../../shared/Toast/toast-type.enum';
import { ModalComponentEnum } from '../../../../../store/modal/modalTypes';
import { Home, Menu, MessageSquare, Plus, Tv, UserPlus } from 'react-feather';
import { NavigationEnum } from '../../../../../navigation/vertical/Navigation.enum';
import { useGetLocation } from '../../../../../store/RoomManagement/resourceManagementHooks';
import { useProfile } from '../../../../../store/Auth/authHooks';
interface BottomBarInterface {
  activeItem: NavigationEnum;
  setMenuVisibility: () => void;
  setNotRouteActiveItem: (value: string) => void;
}

const BottomBar = (props: BottomBarInterface) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const state = store.getState();
  const location = useGetLocation();
  const profile = useProfile();

  const onClickItemWithSubItems = (item: string) => {
    if (item === props.activeItem) {
      const location = history.location;
      const mainLocationName = `/${location.pathname
        .split('/')[1]
        .toLowerCase()}`;
      props.setNotRouteActiveItem(mainLocationName);
    } else {
      props.setNotRouteActiveItem(item);
    }
  };

  const onOpenServiceCallModal = (
    dispatch: any,
    state: any,
    history: any,
    t: TFunction
  ) => {
    const profile = state[AUTH_NAMESPACE];

    if (!profile.profile.permissions.serviceCall) {
      Toast(
        ToastTypeEnum.ERROR,
        t('NO_PERMISSION_TEXT', { operation: t('OPEN_SERVICE_CALL_TEXT') }),
        t
      );
      return;
    }

    if (!profile.profile.phone) {
      return dispatch(
        openOldModalAction(
          ModalComponentEnum.QUESTION_FAIL_OPEN_SERVICE_CALL_MODAL,
          {},
          {},
          () => {
            history.push('/account-settings');
            dispatch(closeOldModalAction());
          }
        )
      );
    }

    dispatch(
      openOldModalAction(
        ModalComponentEnum.NEW_SERVICE_CALL_MODAL,
        { isFullSizeOnMobile: true },
        {},
        () => {}
      )
    );
  };

  const barItems = [
    {
      name: NavigationEnum.DASHBOARDS,
      icon: <Home className="ficon" />,
    },
    {
      name: NavigationEnum.INVITE_GUEST,
      icon: <UserPlus />,
    },
    {
      name: NavigationEnum.SETTINGS,
      icon: <Plus className="ficon" />,
      subItems: (
        [
          profile.locationId !== 7
            ? {
                title: t('BOOK_FITNESS_BOTTOM_BAR'),
                name: NavigationEnum.BOOK_A_FITNESS,
                icon: <i className="icon-dumbbell" />,
              }
            : null,
          {
            title: t('BOOK_ROOM_BOTTOM_BAR'),
            name: NavigationEnum.BOOK_A_ROOM,
            icon: <i className="icon-meeting-board" />,
          },
          profile.locationId !== 7
            ? {
                title: t('BOOK_LOUNGE_BOTTOM_BAR'),
                name: NavigationEnum.BOOK_A_LOUNGE,
                icon: <Tv size={16} />,
              }
            : null,
          profile.locationId === 7
            ? {
                title: t('BOOK_A_ROOF_TOP'),
                name: NavigationEnum.BOOK_A_ROOF_TOP,
                icon: <Tv size={16} />,
              }
            : null,
        ] as any
      ).filter((item: any) => item),
    },

    {
      name: NavigationEnum.MARKETPLACE,
      title: 'Contact support',
      icon: <MessageSquare />,
      action: (dispatch: any, state: any, history: any, t: TFunction) =>
        onOpenServiceCallModal(dispatch, state, history, t),
    },
  ];
  if (location.id === 6) {
    barItems[2].subItems?.push({
      name: NavigationEnum.EVENTS,
      title: t('BOOK_EVENT_BOTTOM_BAR'),
      icon: <i className="icon-glass-martini" />,
    });
  }
  return (
    <div className="bottom-bar">
      {barItems.map((item) => {
        if (item.subItems) {
          return (
            <div
              key={item.name}
              onClick={() => onClickItemWithSubItems(item.name)}
              className={classnames('bottom-bar_item', {
                'bottom-bar_item-active': props.activeItem === item.name,
              })}
            >
              <div className="bottom-bar_item-icon">{item.icon}</div>
            </div>
          );
        }

        if (item.action) {
          return (
            <div
              onClick={() => item.action(dispatch, state, history, t)}
              key={item.name}
              className={classnames('bottom-bar_item')}
            >
              <div className="bottom-bar_item-icon">{item.icon}</div>
            </div>
          );
        }
        return (
          <Link
            to={item.name}
            key={item.name}
            className={classnames('bottom-bar_item', {
              'bottom-bar_item-active': props.activeItem === item.name,
            })}
          >
            <div className="bottom-bar_item-icon">{item.icon}</div>
          </Link>
        );
      })}
      <div className={classnames('bottom-bar_item')}>
        <div className="bottom-bar_item-icon" onClick={props.setMenuVisibility}>
          <Menu className="ficon" />
        </div>
      </div>
      {barItems.find((item) => item.name === props.activeItem)?.subItems && (
        <div className="opened-mobile-sub-items-sidebar">
          {barItems
            .find((item) => item.name === props.activeItem)
            ?.subItems?.map((item: any, index: any) => {
              return (
                <Link
                  to={item.name}
                  key={index}
                  className={classnames('bottom-bar_sub-item')}
                >
                  <div className="bottom-bar_sub-item-icon">{item.icon}</div>
                  <div className="bottom-bar_sub-item-title">{item.title}</div>
                </Link>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default BottomBar;
